const processEnvVars = {
  ACCEDO_ONE_KEY: process.env.ACCEDO_ONE_KEY,
  ACCEDO_ONE_KEY_TIZEN: process.env.ACCEDO_ONE_KEY_TIZEN,
  ACCEDO_ONE_KEY_VIZIO: process.env.ACCEDO_ONE_KEY_VIZIO,
  FIRESTORE_CONFIG: {
    FIRESTORE_KEY: process.env.FIRESTORE_KEY,
    FIRESTORE_KEY_TIZEN: process.env.FIRESTORE_KEY_TIZEN,
    FIRESTORE_KEY_VIZIO: process.env.FIRESTORE_KEY_VIZIO,
    FIRESTORE_DOMAIN: process.env.FIRESTORE_DOMAIN,
    FIRESTORE_PROJECT: process.env.FIRESTORE_PROJECT,
    FIRESTORE_STORAGE: process.env.FIRESTORE_STORAGE,
    FIRESTORE_MESSENGER: process.env.FIRESTORE_MESSENGER,
    FIRESTORE_APP: process.env.FIRESTORE_APP,
    FIRESTORE_APP_TIZEN: process.env.FIRESTORE_APP_TIZEN,
    FIRESTORE_APP_VIZIO: process.env.FIRESTORE_APP_VIZIO,
    FIRESTORE_MEASUREMENT: process.env.FIRESTORE_MEASUREMENT,
    FIRESTORE_MEASUREMENT_TIZEN: process.env.FIRESTORE_MEASUREMENT_TIZEN,
    FIRESTORE_MEASUREMENT_VIZIO: process.env.FIRESTORE_MEASUREMENT_VIZIO,
    UNIVERSAL_ANALYTICS_TIZEN: process.env.UNIVERSAL_ANALYTICS_TIZEN,
  },
};

const environments = {
  development: {
    isProduction: false,
    ...processEnvVars,
  },
  production: {
    isProduction: true,
    adConfigId: '7b9257f9-5da1-46da-9efb-ff1148088515', // default web
    adConfigIdTizen: '73f7e883-a0d4-442e-a210-c6f529c3099b',
    adConfigIdVizio: '21ad399c-6aaf-4e76-81f0-f65732ca7ad8',
    gtmId: 'GTM-KSQ9MM2',
    ...processEnvVars,
  },
};

const environment =
  environments[process.env.NODE_ENV] || environments.development;

module.exports = {
  environments,
  envConfig: environment,
};
